import React, { useEffect, useState } from "react";

const DarkModeSwitch = () => {
  const [isDarkMode, setIsDarkMode] = useState(() => localStorage.getItem("theme") === "dark" || false);

  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      document.documentElement.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }
  }, [isDarkMode]);

  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
  };

  return (
    // <button
    //   onClick={toggleDarkMode}
    //   className="px-4 py-2 rounded-md bg-gray-300 dark:bg-gray-700 text-gray-800 dark:text-gray-100 transition-all"
    // >
    //   {isDarkMode ? "Light Mode" : "Dark Mode"}
    // </button>

    <label className="inline-flex items-center cursor-pointer">
      <input type="checkbox" value="" className="sr-only peer" onChange={toggleDarkMode} checked={isDarkMode} />
      <div
        className="relative w-11 h-6 bg-secondary peer-focus:outline-none rounded-full peer 
        dark:bg-primary peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full 
        peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] 
        after:start-[2px] after:transition-all after:border 
        after:rounded-full after:w-5 after:h-5 dark:after:bg-secondary
        after:bg-primary dark:peer-checked:bg-primary"
      ></div>
    </label>
  );
};

export default DarkModeSwitch;
